import React, { useEffect, useState, useContext } from "react";
import { translate } from "../../../utilities/Translate";
import { AuthContext, ToastContext } from "../../../utilities/contexts";
import { ECLLoader, ECLThemeImage } from "../../../eclComponents/";
import { serviceQuery, staticURL } from "../../../utilities/requests";
import "./LicensePicker.css";

function LicensePicker() {
   const auth = useContext(AuthContext);
   const [licList, setLicList] = useState(null);
   const [error, setError] = useState(null);
   const addToast = useContext(ToastContext);

   useEffect(() => {
      fetchLicenseList();
   }, []);

   const fetchLicenseList = () => {
      serviceQuery({
         message: "LicenseServerInfoMessage",
         query: {},
      })
         .then((res) => {
            setLicList(res.Payload.seats);
         })
         .catch((error) => {
            addToast(
               translate("Data Not Available, Contact System Administrator"),
               "error",
            );
            console.error(error);
            setError("License server request failed");
         });
   };

   const handleSelect = (e) => {
      e.preventDefault();
      const choice = document.querySelector(
         'input[name="license-picker-radio"]:checked',
      );
      if (choice !== null) {
         serviceQuery({
            message: "LicenseWebCheckoutMessage",
            query: {
               seatName: choice.value,
            },
         })
            .then((res) => {
               auth.setLicense(res.Payload.seatId);
               localStorage.setItem("license", res.Payload.seatId);
            })
            .catch((error) => {
               console.error(error);
               addToast(translate("Error checking out license"));
            });
      } else {
         addToast(translate("Please Choose a license"));
      }
   };

   const handleLogout = () => {
      auth.logout();
   };

   //Our handle button takes the checked value from license-picker-radio
   return (
      <div className="license-picker-wrapper">
         <ECLThemeImage
            darkThemeRoute={staticURL + "Logos/S1-Logo-EKPS-Stacked-dark.svg"}
            lightThemeRoute={staticURL + "Logos/S1-Logo-EKPS-Stacked-Light.svg"}
            alt="SourceOne EKPS"
            style={{
               height: "150px",
               display: "flex",
               justifyContent: "center",
            }}
         />
         <div className="license-picker-container">
            {licList !== null ? (
               <>
                  <div className="license-picker-info">
                     <h3>{translate("License Checkout")}</h3>
                     <p>
                        {translate(
                           "Select one of the following licenses and hit checkout to start working. Participant licenses only allow reading and exporting data.",
                        )}
                     </p>
                  </div>
                  <form onSubmit={handleSelect} className="license-picker-form">
                     <fieldset>
                        <legend>{translate("Licenses")}</legend>
                        {licList.map((seat) => {
                           return (
                              <React.Fragment key={seat.seatName + "-key"}>
                                 <div className="license-picker-form-field">
                                    <img
                                       src={
                                          staticURL +
                                          "icons/Eclipse/License_" +
                                          seat.seatName +
                                          "_White.svg"
                                       }
                                       alt={translate(seat.seatName + " Icon")}
                                    />
                                    <label
                                       htmlFor={
                                          "license-picker-" + seat.seatName
                                       }
                                    >
                                       {seat.seatName}
                                    </label>
                                    <input
                                       id={"license-picker-" + seat.seatName}
                                       value={seat.seatName}
                                       type="radio"
                                       name="license-picker-radio"
                                       required
                                    ></input>
                                 </div>
                                 <p className="license-picker-detail">
                                    {translate(
                                       `Available Seats: ${seat.avalibleCount} of ${seat.seatCount}`,
                                    )}
                                 </p>
                              </React.Fragment>
                           );
                        })}
                     </fieldset>
                     <div className="license-picker-button-bar">
                        <button type="submit" name="Select License">
                           {translate("Select")}
                        </button>
                        <button onClick={handleLogout} type="button">
                           {translate("Log Out")}
                        </button>
                     </div>
                  </form>
               </>
            ) : (
               <ECLLoader error={error} />
            )}
         </div>
      </div>
   );
}

export default LicensePicker;
